export const MASS_FOOD_QUANTITY_UNITS = ['gram', 'milliliter'] as const;

/** Units whose gram weight depends on the food: countable pieces, servings, and volumes. */
export const NON_MASS_FOOD_QUANTITY_UNITS = [
  'piece',
  'slice',
  'serving',
  'cup',
  'tablespoon',
  'teaspoon',
] as const;

export const FOOD_QUANTITY_UNITS = [
  ...MASS_FOOD_QUANTITY_UNITS,
  ...NON_MASS_FOOD_QUANTITY_UNITS,
] as const;

export type FoodQuantityUnit = (typeof FOOD_QUANTITY_UNITS)[number];

export type MassFoodQuantityUnit = (typeof MASS_FOOD_QUANTITY_UNITS)[number];

export type NonMassFoodQuantityUnit = (typeof NON_MASS_FOOD_QUANTITY_UNITS)[number];
